<template>
<div v-if="showOnMobile" class="mobile-header__wrapper">
    <div class="mobile-account__header-back">
        <span v-if="!closeText || alsoNeedArrowLeft"  @click="handleBack()">
            <SvgIcon icon="sign.arrow.left"></SvgIcon>
            
        </span> 
    </div>
    <div >{{$t(title)}}</div>
    
    <div class="mobile-account__header-back right-text">
        <span @click="handleClose()" v-if="closeText">
            {{ $t('CLOSE') }}
        </span>
    </div>
</div>
</template>

<script>
import {mapGetters,mapActions} from 'vuex'
export default {
    props: {       
        redirectTo: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default:''
        },
        closeText: {
            type: Boolean,
            default: false
        },
        alsoNeedArrowLeft: {
            type: Boolean,
            default: false
        },
        backCustomize: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapGetters([
            'currentLocale',
            "isMobile"
        ]),
    },
    data() {
        return {
            showOnMobile: false,
        }
    },
    methods: {
        init() {
            this.showOnMobile = this.isMobile;
        },
        handleBack() {
            if(this.backCustomize) {
                this.$emit('handleBack')
            } else {
                 this.handleClose()  
            }
        },
        handleClose() {
            this.speicalHandling();
    
            if (this.redirectTo === '') {
                this.$router.go(-1)
            } else {
                this.$router.push(`/${this.currentLocale}`); 
            } 
        },
        
        speicalHandling() {
            //remove worldcup knockout session storage data;
            sessionStorage.removeItem("worldcupKnockout");
        }

    },
}
</script>

<style>
.mobile-header__wrapper{
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--color-background-default-secondary);
}
.right-text {
    width: auto;
    font-family: var(--weight-600);
    margin-right: 16px;
    /* padding-right: 0.8rem; */
}
</style>